// src/components/profile-components/FavoriteProductsList.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, HeartOff, ArrowLeft } from 'lucide-react';

import { getFavoriteProducts } from '../../services/profileService';
import VerticalContentCard from '../Category/VerticalContentCard'; 
import { useAuthContext } from '../../context/AuthContext'; 

export function FavoriteProductsList() {
    const [favoritesData, setFavoritesData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [errorStatus, setErrorStatus] = useState(null);
    
    const { profileUpdateKey } = useAuthContext();

    useEffect(() => {
        const fetchFavorites = async () => {
            console.log("FAVORITES DEBUG: Fetching started...");
            try {
                setIsLoading(true);
                const responseData = await getFavoriteProducts();
                
                // ✅ اصلاح حیاتی: مدیریت ایمن ساختار پاسخ
                // اگر results نبود، خودش را به عنوان آرایه در نظر بگیر، وگرنه آرایه خالی
                const rawItems = responseData?.results || (Array.isArray(responseData) ? responseData : []);
                
                // ✅ استخراج ایمن محصول (با چک کردن کلیدهای احتمالی بک‌اِند)
                const products = rawItems
                    .map(item => item?.product || item?.product_details || item)
                    .filter(p => p !== null && typeof p === 'object');
                
                setFavoritesData(products.slice(0, 10));
                setIsError(false);

            } catch (error) {
                console.error("FAVORITES DEBUG: Error:", error);
                setIsError(true);
                if (error.response) {
                    setErrorStatus(error.response.status);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchFavorites();
    }, [profileUpdateKey]);

    // --- وضعیت‌های رندر (Loading, Error, Empty) همان ساختار قبلی شماست اما با امنیت بیشتر ---

    if (isLoading) {
        return (
            <div className="flex justify-center items-center p-10 rtl">
                <Loader2 className="w-6 h-6 animate-spin text-purple-700" />
                <span className="mr-3 text-gray-600 font-medium">در حال بارگذاری علاقه‌مندی‌ها...</span>
            </div>
        );
    }

    if (isError) {
        if (errorStatus === 401) {
             return (
                <div className="p-6 bg-white rounded-lg shadow-sm text-center text-gray-500 rtl border border-gray-100">
                    <HeartOff className="w-10 h-10 mx-auto mb-3 text-gray-400" />
                    <p className="font-semibold">بخش علاقه‌مندی‌ها</p>
                    <p className="text-[11px] mt-2 font-medium">برای مشاهده موارد دلخواه خود، ابتدا وارد شوید.</p>
                </div>
            );
        }
        return (
            <div className="p-4 bg-red-50 text-red-700 rounded-lg rtl text-center border border-red-100 font-medium">
                خطا در دریافت اطلاعات علاقه‌مندی‌ها. لطفاً اتصال خود را چک کنید.
            </div>
        );
    }

    if (favoritesData.length === 0) {
        return (
            <div className="p-10 bg-white rounded-lg shadow-sm text-center text-gray-500 rtl border border-gray-100">
                <HeartOff className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                <p className="font-semibold text-gray-700">هنوز موردی را اضافه نکرده‌اید</p>
                <p className="text-[11px] mt-2">محتواهایی که دوست دارید را لایک کنید تا اینجا نمایش داده شوند.</p>
            </div>
        );
    }

    return (
        <div className="space-y-4 rtl text-right">
            <div className="flex justify-between items-center">
                <h3 className="text-gray-800 font-bold text-[12px] md:text-xl">
                    محتوای مورد علاقه شما
                </h3>
                <Link 
                    to="/profile/favorites" 
                    className="text-xs font-semibold text-gray-700 hover:text-purple-900 transition flex items-center"
                >
                    <span>بیشتر</span>
                    <ArrowLeft className="w-4 h-4 mr-1" />
                </Link>
            </div>
            
            <div className="flex overflow-x-auto space-x-4 space-x-reverse py-2 no-scrollbar">
                {favoritesData.map(product => (
                    <div 
                        key={product.id} 
                        className="w-[280px] sm:w-[320px] flex-shrink-0"
                    >
                        <VerticalContentCard data={product} />
                    </div>
                ))}
            </div>
        </div>
    );
}